import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { DashboardService } from '@app/services/dashboard.service';

export interface TeamListDialogData {
  userId: string;
}

export interface TeamMember {
  id: string;
  name: string | null;
  emailId: string | null;
  companyName: string | null;
  branch: string | null;
  department: string | null;
  designation: string | null;
  sapCode: string | null;
  empId: string | null;
  mobileNo: string | null;
  grade: string | null;
}

@Component({
  selector: 'app-team-list',
  standalone: true,
  imports: [MatDialogModule, NgxSkeletonLoaderModule],
  templateUrl: './team-list.component.html',
  styleUrl: './team-list.component.scss',
})
export class TeamListComponent implements OnInit {
  isLoading = true;
  team: TeamMember[] = [];
  search = '';

  constructor(
    private dashboardService: DashboardService,
    private dialogRef: MatDialogRef<TeamListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TeamListDialogData
  ) {}

  ngOnInit(): void {
    this.dashboardService.GetTeamListData(this.data?.userId).subscribe({
      next: (res: any) => {
        this.team = res?.data?.teamListData ?? [];
      },
      error: () => {
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  get filteredTeam(): TeamMember[] {
    const term = this.search.trim().toLowerCase();
    if (!term) return this.team;
    return this.team.filter((item) =>
      [item.name, item.emailId, item.empId, item.sapCode, item.mobileNo, item.department]
        .some((value) => value?.toLowerCase().includes(term))
    );
  }

  clean(value: any): string | null {
    const text = value === null || value === undefined ? '' : String(value).trim();
    return text && text.toLowerCase() !== 'null' ? text : null;
  }

  initials(item: TeamMember): string {
    const parts = (this.clean(item?.name) ?? '').split(/\s+/).filter(Boolean);
    const letters =
      parts.length > 1 ? parts[0][0] + parts[parts.length - 1][0] : parts[0]?.[0];
    return (letters || item?.emailId?.charAt(0) || '?').toUpperCase();
  }

  close(): void {
    this.dialogRef.close();
  }
}
